import { Drawer } from "antd";
import BidToolForm from "../TruckDetails/BidToolForm";
import { PlacementPositions } from "../../../../../enums/PlacementPositionsEnums";
import { DrawerHeaderStyle } from "../../../../../constants/CustomStyles";
import styles from "../MaterialTruckDetails.module.scss";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import Form from "../../../../Form";

interface BidToolReferenceFormProps {
    isOpen: boolean;
    handleClose: () => void;
    selectedOrderData: object;
};

const BidToolReferenceForm = ({
    isOpen,
    handleClose,
    selectedOrderData,
}: BidToolReferenceFormProps) => {

    return (
        <>
          <Drawer
            visible={isOpen}
            placement={PlacementPositions.RIGHT}
            width={"95%"}
            height={"100vh"}
            title={
                <span className={styles.BidToolHeader}>Bid Tool</span>
            }
            onClose={handleClose}
            destroyOnClose
            headerStyle={DrawerHeaderStyle}
          >
            <Form defaultValues={selectedOrderData}>
              {() => <BidToolForm isReference={true} />}
            </Form>
            
          </Drawer>
        </>
    );
};

export default BidToolReferenceForm;